(function ($) {
  $(function () {
    $(window).on('scroll load', function () {
      if ($(this).scrollTop() > $(document).height() * 0.1) {
        $('#scroll_to_top').addClass('active');
      } else {
        $('#scroll_to_top').removeClass('active');
      }
    });

    $('#scroll_to_top').on('click', function () {
      $('html, body').animate({scrollTop: 0}, 700);
    })
  });
})(jQuery);


// WEBPACK FOOTER //
// ./assets/js/scroll-top.js